import React from 'react';
import moment from 'moment';
import _ from 'lodash';

import Typography from '@material-ui/core/Typography';
import { VerticalTimeline } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import Icon from '../../../Common/Icon';
import { sortDates } from '../../../../utils/helper';
import TimelineItem from './Item';

import styles from './styles';

const getLatestCompletion = (completions = []) => {
  return completions.reduce((res, completion) => {
    if (!res || moment(res.at).isBefore(completion.at)) {
      return completion;
    }

    return res;
  });
};

const generateTimelineItems = (job, task) => {
  console.log('generateTimelineItems', task);
  const items = [];
  (task.stages || []).forEach((stage) => {
    const profileStage = job.profile.stages.find((s) => s.id === stage.id);
    console.log('profileStage', profileStage);
    if (stage.completed && stage.completed.length) {
      const completion = getLatestCompletion(stage.completed);
      items.push({
        id: `sc-${stage.id}`,
        type: 'stagecompleted',
        stage: profileStage,
        by: completion.by,
        date: completion.at,
      });
    }

    _.range(0, 2).forEach((i) => {
      items.push({
        id: `photo-${stage.id}-${i}`,
        type: 'photo',
        stage: profileStage,
        by: { name: 'YOU' },
        date: new Date(),
        photos: ['1', '2'],
      });
    });
  });

  console.log('items', items);
  return items.sort((a, b) => sortDates(b.date, a.date));

  /*
  stage => stage.completed && stage.completed.length
   */
};

const TaskTimeline = ({ job, task }) => {
  const items = generateTimelineItems(job, task);
  if (!items.length) {
    return (<div style={styles.nohistory}>
      <Icon name="computer"/>
      <Typography variant="body2">No timeline history</Typography>

    </div>);
  }

  return (<div style={styles.container}>
      <VerticalTimeline>
        {items.map((item) => (<TimelineItem
          key={item.id}
          item={item}
        />))}
      </VerticalTimeline>
    </div>
  );
};

export default TaskTimeline;



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskDialog/TaskTimeline/index.js